// AUTO-GENERIERT von scripts/generateRegistry.js — NICHT von Hand editieren.
export const registry = {
  "actions": () => import('../modules/actions.js'),
  "delayeddoi": () => import('../modules/delayeddoi.js'),
  "entertainment": () => import('../modules/entertainment.js'),
  "header": () => import('../modules/header.js'),
  "images": () => import('../modules/images.js'),
  "infobox": () => import('../modules/infobox.js'),
  "listmanage": () => import('../modules/listmanage.js'),
  "memberoftheweek": () => import('../modules/memberoftheweek.js'),
  "message": () => import('../modules/message.js'),
  "messagepoll": () => import('../modules/messagepoll.js'),
  "minichat": () => import('../modules/minichat.js'),
  "myimages": () => import('../modules/myimages.js'),
  "onesignal": () => import('../modules/onesignal.js'),
  "profile": () => import('../modules/profile.js'),
  "profilecompletion": () => import('../modules/profilecompletion.js'),
  "profilesettings": () => import('../modules/profilesettings.js'),
  "pwa": () => import('../modules/pwa.js'),
  "register": () => import('../modules/register.js'),
  "search": () => import('../modules/search.js'),
  "shop": () => import('../modules/shop.js'),
  "sidebarnavi": () => import('../modules/sidebarnavi.js'),
  "site": () => import('../modules/site.js'),
  "support": () => import('../modules/support.js'),
  "theme": () => import('../modules/theme.js'),
  "visitors": () => import('../modules/visitors.js'),
};
